
export enum SurveyType {
    regular = 'regular',
    MHC = 'MHC',
    onboarding = 'onboarding',
    matching = 'matching',
    wpoInstantHelp = 'wpoInstantHelp',
    wpoScheduling = 'wpoScheduling',
    // only used for forward-compatibility: when the api is updated with a new survey type
    // and the user hasn't updated their app yet
    unknown = 'unknown',
}
